module.exports = __webpack_public_path__ + "0c1fc439d9c8b9c9ed416e2d108609b9.jpg";